import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import type { Player } from '../services/api';
import PlayerCard from './PlayerCard';
import type { PlayerStatus } from './PlayerKanban';
import { Box, Typography, Paper } from '@mui/material';

interface PlayerColumnProps {
  id: PlayerStatus;
  title: string;
  players: Player[];
  isDropDisabled?: boolean;
}

const PlayerColumn: React.FC<PlayerColumnProps> = ({ id, title, players, isDropDisabled = false }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
    disabled: isDropDisabled,
  });

  return (
    <Paper 
      ref={setNodeRef} 
      elevation={2}
      sx={{
        p: 1.5,
        borderRadius: '8px',
        backgroundColor: isOver ? 'action.hover' : 'background.default',
        minHeight: '200px', // Ensure columns have a minimum height
        transition: 'background-color 0.2s ease-in-out',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h6" component="h3" sx={{ mb: 1.5, fontWeight: 'bold' }}>
        {title} <span style={{ fontWeight: 'normal' }}>({players.length})</span>
      </Typography>
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '8px',
          flexGrow: 1, // Allow this box to grow and fill space
        }}
      >
        {players.map(player => (
          <PlayerCard 
            key={player.id} 
            player={player} 
            isDragDisabled={id === 'on_court'} 
          />
        ))}
      </Box>
    </Paper>
  );
};

export default PlayerColumn;